import { render, staticRenderFns } from "./BookLibrary.vue?vue&type=template&id=4c6b23d4&scoped=true"
import script from "./BookLibrary.vue?vue&type=script&lang=js"
export * from "./BookLibrary.vue?vue&type=script&lang=js"
import style0 from "./BookLibrary.vue?vue&type=style&index=0&id=4c6b23d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b23d4",
  null
  
)

export default component.exports